import { CommonModule } from "@angular/common";
import { NgModule, Optional, SkipSelf } from "@angular/core";
import { throwIfAlreadyLoaded } from "./guard/module-import.guard";
import { DynamicScriptLoaderService } from "./service/dynamic-script-loader.service";

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [
    DynamicScriptLoaderService,
  ],
})
export class CoreModule {
  constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
    throwIfAlreadyLoaded(parentModule, "CoreModule");
  }
}
